import React from 'react';

const GeometricShapes = () => {
  return (
    <div className="w-full h-full relative overflow-hidden flex items-center justify-center">
      <div
        className="absolute w-64 h-64 border border-[#00FFD1] opacity-20 rounded-full"
        style={{
          animation: 'rotateShape 30s linear infinite'
        }}
      />
      <div
        className="absolute w-48 h-48 border border-[#00FFD1] opacity-15"
        style={{
          animation: 'rotateShape 40s linear infinite reverse'
        }}
      />
      <div
        className="absolute w-32 h-32 bg-[#00FFD1] opacity-10"
        style={{
          clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
          animation: 'rotateShape 35s linear infinite'
        }}
      />
    </div>
  );
};

export default GeometricShapes;